@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.step-title {
  font-size: 1rem;
  line-height: 24px;
  font-weight: 500;
  margin-top: @space-16;
  display: inline-block;
}

.step-info {
  margin-top: @space-8;
  color: var(--grey-600);
}

.step-button-panel {
  gap: @space-16;
  align-items: center;
  margin-top: @space-16;
}

.move-to-marketplace-btn {
  height: auto;
}

.learn-more-btn {
  display: flex;
  gap: @space-4;
  align-items: center;
  font-size: 14px;
  > svg {
    height: 16px;
    margin-left: @space-4;
  }
}
